

/// <reference path="RenderTemplate.ts" />

// Generated class CommunicationTemplate_ManagedObject

class CommunicationTemplate_ManagedObject extends RenderTemplate
{
}
